module.exports = __webpack_public_path__ + "img/home-bg.d84d9d07.webp";